import resourceConfigSchema from '@/features/controller/configuration/models/resourceConfigSchema.json'

type EnrichedResourceConfigSchema = typeof resourceConfigSchema & {
  definitions: { BatteryResource: { properties: { id: { type: string; enum?: string[] } } } }
}

/**
 * Returns the resource.json schema with `BatteryResource.id` constrained to the given resource UUIDs.
 * Other resource types (none today; the schema's `Resource` is a single-member union of `BatteryResource`)
 * would need their own enrichment if added.
 *
 * Returns `null` when no resource IDs are provided, signalling "fall back to the static schema".
 */
export function enrichBatteryResourceIdsInSchema(resourceIds: string[]): object | null {
  if (resourceIds.length === 0) {
    return null
  }
  const enriched = structuredClone(resourceConfigSchema) as EnrichedResourceConfigSchema
  enriched.definitions.BatteryResource.properties.id.enum = resourceIds
  return enriched
}
